/* eslint-disable */
import { message } from 'antd'
import { enableMapSet } from 'immer'


// NPS配置
function callBack() {
  window.shopCommonComponents.registerCommonComponents() // 注册公共组件
}

function loadScript(url, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = url
  script.async = true
  document.body.appendChild(script)
  script.onload = function() {
    callback()
  }
}
loadScript(
  '//jm-static.jd.com/shop-common-components/shop-common-components.iife.js?appId=W9OPKOQIBDHZ9UP6LPUE',
  callBack
)


enableMapSet()

export const dva = {
  config: {
    onError(e) {
      e.preventDefault()
      console.log(e)
      message.destroy()
      if (e.message) {
        if (e.message == 'Failed to fetch') {
          message.error('请检查您的网络连接')
        } else {
          message.error(e.message)
        }
      }
    },
  },
  plugins: [],
}

sessionStorage.setItem('$XDataHost', 'https://query-panel.xiaoduoai.com/')
